<template>
<!-- <div> -->
 <v-dialog v-model="show" persistent max-width="400px">
    <v-card >
                  <v-toolbar
          color="orange lighten-1"
          dark
        >

          <v-toolbar-title  class="headline">Anmäl elevförändring</v-toolbar-title>
 <v-spacer></v-spacer>

          <v-btn icon @click="showWarningSnackbar('Här rapporterar du till skolsköterskan om en elev har börjat eller slutat på skolan.')">
            <v-icon>help</v-icon>
          </v-btn>
        </v-toolbar>
            <v-card-text>
              <v-container>
                <v-flex>
             <v-text-field
                  label="Namn"
                  hint="Namn på eleven."
                  v-model="student.name"
                ></v-text-field>
                            <v-text-field
                  label="Klass"
                  hint="Den berörda klassen."
                  v-model="student.class"
                ></v-text-field>

    <v-radio-group label="Aktivitet" v-model="student.activity">
      <v-radio
        label="Börjat på skolan"
        value="börjat"
      ></v-radio>
      <v-radio
        label="Slutat på skolan"
        value="slutat"
      ></v-radio>
            <v-radio
        label="F-varning"
        value="f-varning"
      ></v-radio>
      <v-radio
        label="F"
        value="f"
      ></v-radio>
    </v-radio-group>
    <div  v-if="student.activity=='f' || student.activity=='f-varning'">
                                <v-text-field
                  label="Ämne"
                  hint="Det berörda ämnet."
                  v-model="student.course"
                ></v-text-field>
                    <v-radio-group label="Typ:" v-model="student.typ">
      <v-radio
        label="Eleven har inte testat alla kunskapskrav"
        value="Eleven har inte testat alla kunskapskrav"
      ></v-radio>
      <v-radio
        label="Eleven uppfyller inte kunskapsmålen"
        value="Eleven uppfyller inte kunskapsmålen"
      ></v-radio>
    </v-radio-group>
      <v-select
          :items="causelist"
          label="Upplevd anledning:"
         v-model="student.cause"
          solo
        ></v-select>
                      
     <v-textarea
          solo
          v-model="student.plan"
          name="input-7-4"
          label="Åtgärdsplan"
        ></v-textarea>
    </div>
    <v-flex justify="center">
       <p  class="headline">Startdatum för ärende</p>
    <v-date-picker v-model="student.changeDate" color="purple ligthen-2"></v-date-picker>
  </v-flex>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="show = false">
                Avbryt
              </v-btn>
              <v-btn
                color="green lighten-1"
                text
                dark
                @click="student.reporter=reporter;student.schoolId=schoolId;nurseCheck(student); Endtext();  student= {name:'', class:'', activity:'' ,changeDate: null};show = false"
              >
                Anmäl
              </v-btn>
            </v-card-actions>
          </v-card>
 </v-dialog>
   <!-- <v-btn @click="show=false" dark color="green ligthen-1">
    Anmäl elevförändring
  </v-btn>
</div> -->
</template>
<script>
import { mapActions,mapGetters } from "vuex";
export default {
    name:"SendtoNurse",

  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    },
  
    ...mapGetters('ehtmembers', ['member']),
    ...mapGetters('teachers', ['teacher']),
    ...mapGetters('cases', ['cases', 'casesnames']),

  
  },
    props:{
        schoolId: String,
        reporter: String,
        As: String,
        value: Boolean
    },
data() {
    return {
      student: {name:"", class:"", activity:"" ,changeDate: null},
      causelist:["Kunskapsinhämntning" ,
"Måluppfyllelse",
"Hälsa" ,
"Närvaro" ,
"Koncentration och impulskontroll ",
"Socialt" ]
      // dialog:false,
      // show:false,
    };
  },
  methods: {

Endtext(){
  if (this.student.activity=="f" || this.student.activity=="f-varning") {
    if (this.As =="EHT") {
       this.showSuccessSnackbarInfinity('Under elevförändring kan du nu ge återkoppling till ärendet.');
    }
    else
  this.showSuccessSnackbar('Elevförändring inskickad.Elevhälsan kommer återkomma med återkoppling, tack!');

  }
   else if(this.student.activity=="slutat")
  {
    if (this.As=="teacher") {
  this.showSuccessSnackbar('Elevavslutat inskickad, tack!');
    }
    else
  this.showSuccessSnackbarInfinity('Fyll i överlämningsblanketten till elevens nästkommande skola i elevförändringen.');
  }
  else
  {
    if (this.As=="teacher") {
  this.showSuccessSnackbar('Elevstart inskickad, tack!');
    }
  this.showSuccessSnackbarInfinity('Skicka ut överlämningsblanketten till elevens föregående skola i elevförändringen.');

  }
},
    ...mapActions(['showSuccessSnackbar','showSuccessSnackbarInfinity','showWarningSnackbar']),
    ...mapActions('ehtmembers', ['nurseCheck']),
  
}
}
</script>
<style >

</style>